import PilarCard from '~/components/Molecules/PilarCard/PilarCard.vue'
import { getDeviceSize } from '~/utils/device'

export default {
  props: {
    love: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isMobile: null,
      card: PilarCard,
      swiperOptions: {
        watchOverflow: true,
        observer: true,
        slidesPerView: 1.2,
        spaceBetween: 24,
        grabCursor: true,
        breakpoints: {
          480: {
            slidesPerView: 1.8,
            spaceBetween: 28,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 28,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.checkDeviceSize)

      window.dispatchEvent(new Event('resize'))

      this.checkDeviceSize()
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkDeviceSize)
  },

  methods: {
    checkDeviceSize() {
      const device = getDeviceSize()

      this.isMobile = /mobile(?:\-(?:l|[m]))?/.test(device)
    },
  },
}
